import React from 'react';
import Icon from '../../../components/AppIcon';
import LeadCard from './LeadCard';

const MobileStageView = ({ stage, leads, onAssignOwner, onAddNote, onConvert }) => {
  const stageConfig = {
    'new': { label: 'New Leads', icon: 'Inbox', color: 'text-primary' },
    'contacted': { label: 'Contacted', icon: 'Phone', color: 'text-secondary' },
    'qualified': { label: 'Qualified', icon: 'CheckCircle', color: 'text-success' },
    'proposal': { label: 'Proposal Sent', icon: 'FileText', color: 'text-warning' },
    'negotiation': { label: 'Negotiation', icon: 'MessageSquare', color: 'text-accent' },
    'lost': { label: 'Lost', icon: 'XCircle', color: 'text-error' }
  };

  const config = stageConfig?.[stage] || stageConfig?.['new'];
  const stageLeads = leads?.filter(lead => lead?.stage === stage);

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name={config?.icon} size={20} color={`var(--color-${config?.color?.replace('text-', '')})`} />
          <h3 className="font-heading font-semibold text-foreground text-base">
            {config?.label}
          </h3>
        </div>
        <span className="px-2 py-1 bg-primary bg-opacity-10 text-primary rounded-lg text-xs font-semibold data-text">
          {stageLeads?.length}
        </span>
      </div>
      {stageLeads?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Icon name="Inbox" size={48} color="var(--color-muted-foreground)" className="mb-3 opacity-30" />
          <p className="text-sm caption text-muted-foreground">No leads in this stage</p>
        </div>
      ) : (
        <div className="space-y-3">
          {stageLeads?.map(lead => (
            <LeadCard
              key={lead?.id}
              lead={lead}
              onAssignOwner={onAssignOwner}
              onAddNote={onAddNote}
              onConvert={onConvert}
              onStageChange={() => {}}
              isDragging={false}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileStageView;